// DS6.9.1
import React, { useMemo, useContext } from 'react';
import cn from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import Badge from '@wix/da-ds/pkg/Badge';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink/PlainButtonOrLink';
import { usePushModal } from '../../utils/hooks/usePushModal';
import { ModalType } from '../../Modals/redux/types';
import CustomNotificationProvider from '../../Notifications/CustomNotificationContext';
import PopoverNotification from '../../Notifications/PopoverNotification';
import { NotificationType } from '../../Notifications';
import { ScreenSizeContext } from '../../Measured';
import CoreBadgeButton from '../CoreBadgeButton';
import { badgeNotificationsFilter } from '../utils';
import s from './CoreBadgeList.scss';
const STACKED_BADGES_THRESHOLD = 2;
const CoreBadgeList = ({ badges , recipient , targetTypeId , targetItemId , notificationQueueName , biData , className , size ='large'  })=>{
    const isMobile = useContext(MobileContext);
    const { width: screenWidth  } = useContext(ScreenSizeContext);
    const pushAwardsModal = usePushModal(ModalType.RECEIVED_AWARDS);
    var _curr_stackCount;
    // tally up the total of badges awarded
    const badgeCount = useMemo(()=>badges.reduce((prev, curr)=>prev + ((_curr_stackCount = curr.stackCount) !== null && _curr_stackCount !== void 0 ? _curr_stackCount : 0), 0), [
        badges
    ]);
    if (badges.length < 1) {
        return null;
    }
    // only last four badges
    const visibleBadges = badges.slice(-4);
    // if over 1000 badges, represent as 1k
    const totalBadges = badgeCount > 999 ? `${Math.floor(badgeCount / 1000)}k` : badgeCount;
    // if "stacked" it means the badges will be displayed in an overlapped manner
    const isStacked = visibleBadges.length > STACKED_BADGES_THRESHOLD;
    return /*#__PURE__*/ React.createElement(CustomNotificationProvider, {
        queueName: notificationQueueName
    }, /*#__PURE__*/ React.createElement(Section, {
        className: cn(s['root'], s[`size-${size}`], isStacked && s['stacked'], className)
    }, /*#__PURE__*/ React.createElement(VisuallyHidden, null, /*#__PURE__*/ React.createElement(Heading, null, "Badge Awards")), visibleBadges.map((badge, idx)=>badge.stackCount && /*#__PURE__*/ React.createElement(PopoverNotification, {
            key: `CoreBadgeList-${idx}`,
            placement: isMobile || screenWidth <= 1250 ? 'top' : undefined,
            secondaryPlacement: isMobile || screenWidth <= 1250 ? 'end' : undefined,
            className: cn(s['button'], idx === 0 && s['button-first']),
            contentClassName: s['notification'],
            notificationTypes: [
                NotificationType.Badge
            ],
            notificationFilter: badgeNotificationsFilter(badge.name)
        }, /*#__PURE__*/ React.createElement(CoreBadgeButton, {
            key: badge.name,
            type: badge.name,
            badges: badges,
            recipient: recipient,
            targetTypeId: targetTypeId,
            targetItemId: targetItemId,
            biData: biData,
            hideTooltip: true
        }, /*#__PURE__*/ React.createElement(Badge, {
            badge: badge,
            className: s['badge'],
            size: size === 'large' ? 24 : 16
        })))), totalBadges && /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: s['badge-count'],
        biData: biData,
        onClick: ()=>pushAwardsModal({
                badges: visibleBadges,
                recipient,
                typeId: targetTypeId,
                itemId: targetItemId
            })
    }, totalBadges)));
};
CoreBadgeList.displayName = 'CoreBadgeList';
export default CoreBadgeList;
